/* eslint sort-keys: ["error", "asc", {caseSensitive: false}] */
import { buildScopedTranslationFunction } from '../../lib/translate';

export default buildScopedTranslationFunction({
  de: { clockedInSince: 'Eingestempelt seit {{time}} Uhr' },
  en: { clockedInSince: 'clocked in since {{time}}' },
});
